<template>
    <div class="outline-echart">
        <template>
            <div v-if="Object.keys(echartArray).length !== 0">
                <div class="echart-content" v-if="echartArray.offline">
                    <Header :class="'header-echart  no-top-border'" :leftIcon="headerCfg.offline.leftIcon" :rightIcon="headerCfg.offline.rightIcon" />
                    <LineEchart :className="'echarts'" :chartData="echartArray.offline" />
                </div>

                <div class="echart-content" v-if="echartArray.powerout">
                    <Header :class="'header-echart'" :leftIcon="headerCfg.powerout.leftIcon" :rightIcon="headerCfg.powerout.rightIcon" />
                    <LineEchart :className="'echarts'" :chartData="echartArray.powerout" />
                </div>

                <div class="echart-content" v-if="echartArray.configure">
                    <Header :class="'header-echart'" :titleVal="'配置分析'" :leftIcon="headerCfg.configure.leftIcon" :rightIcon="headerCfg.configure.rightIcon" />
                    <LineEchart :className="'echarts'" :chartData="echartArray.configure" />
                </div>
            </div>

            <div v-else>
                <el-empty :description="$t('integration.no_selected_device_data')"></el-empty>
            </div>
        </template>
        <setDataDia :title="title" ref="analSet" :isShow.sync="isShow" :config="diaConfig" :defaultSetting="defaultSetting" @impl="diaSaveImpl" />
    </div>
</template>
<script>
import { analyseGetDataAnalysis, analyseSaveSetting } from '@/api/modules/dataBoard.js';
import Header from '../components/Header.vue';
import LineEchart from '@/components/echart/LineBarEchart.vue';
import setDataDia from '../../dialog/analItem.vue';

import sensorConfig from './config/sensorConfig';
import gatewayConfig from './config/gatewayConfig';
import displayConfig from './config/displayConfig';
import relayConfig from './config/relayConfig';
import defaultSetting from './config/defaultSetting';
import { offline, configure, powerout } from './config/headerConfig';
import bus from '@/utils/bus';
export default {
    props: ['stats', 'echartArray', 'deviceIcon', 'config', 'saveList'],
    watch: {
        deviceIcon(newVal) {
            switch (newVal) {
                case '0':
                    this.diaConfig = sensorConfig;
                    break;
                case '1':
                    this.diaConfig = gatewayConfig;
                    break;
                case '2':
                    this.diaConfig = displayConfig;
                    break;
                case '3':
                    this.diaConfig = relayConfig;
                    break;
            }
        },
        config: {
            handler(newVal) {
                if (typeof newVal === 'string') newVal = JSON.parse(newVal);
                // 全局配置会影响局部配置
                this.localConfig = JSON.parse(JSON.stringify({ ...this.localConfig, ...newVal }));
                this.$refs.analSet.setConfig(newVal || {});
            }
        }
    },
    components: {
        Header,
        LineEchart,
        setDataDia
    },
    data() {
        return {
            defaultSetting,
            diaConfig: sensorConfig,
            // Header配置
            headerCfg: {
                offline,
                configure,
                powerout
            },
            // 设置数据
            isShow: false,
            title: '',
            // 中间图表数据请求 需要一个个去请求 其中不同设备有不同的数据项
            outLineData: [], //离线
            breakpointData: [], //断点
            configData: [], //配置,
            // 局部配置
            localConfig: JSON.parse(JSON.stringify(defaultSetting))
        };
    },
    mounted() {},
    methods: {
        handleClick(item, index) {
            if (item.id === 1) {
                alert($t('integration.refresh_content'));
            } else if (item.id === 2) {
                this.isShow = true;
                this.title = $t('integration.data_analysis_settings');
            } else {
                this.$confirm(this.$t('integration.are_you_sure_about_this_operation?'), this.$t('public.prompt'), {
                    confirmButtonText: this.$t('messageTitle.Yes'), // 确定按钮的文案
                    cancelButtonText: this.$t('messageTitle.Cancel'), // 取消按钮的文案
                    type: 'warning'
                })
                    .then(() => {
                        // mock假删除
                        this.echartArray.splice(index, 1);
                    })
                    .catch(() => {});
            }
        },
        saveSetting(obj) {
            analyseSaveSetting({
                device_catalog: this.deviceIcon,
                ...obj
            }).then(res => {
                if (res.result) {
                    this.isShow = false;
                    this.$message.success(res.state.msg);
                }
            });
        },
        diaSaveImpl(obj) {
            // console.log(config,obj);
            // 保存至本地配置 不需要混入全局配置  刷新是根据局部配置进行刷新
            this.localConfig = { ...this.localConfig, ...obj };
            bus.$emit('refreshChart', obj);
            // this.$emit('updateEchart', { childrenList: this.saveList, obj: { ...defaultSetting, ...obj } });
        }
    },
    mounted() {
        bus.$on('refreshLocal', localConfig => {
            this.localConfig = localConfig;
        });
    },
    beforeDestroy() {
        bus.$off('refreshLocal');
    }
};
</script>

<style lang="scss" scoped>
.outline-echart {
    height: 100%;
    margin: 0 5px;
    flex: 1;
    border: 1px solid #cccccc;
    box-sizing: border-box;
    overflow: auto;

    .echart-content {
        width: 100%;
        height: 400px;
    }

    .header-echart {
        border-top: 1px solid #cccccc;
    }

    .no-top-border {
        border-top: 0;
    }

    .echarts {
        width: 100%;
        height: 360px !important;
    }
}
</style>
